module.exports = __webpack_public_path__ + "a936c3a962b4fa53e90cd249e5851273.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/shelton_capital_management.png
// module id = 1526
// module chunks = 0